import { createClient } from '@/utils/saas/supabase/client'

// @@TODO: Wrap all database queries in useQuery / useMutation hooks
// @@BUG:
/*
Conversion of type 'undefined' to type 'Employee[]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
Type 'undefined' is not comparable to type 'Employee'.ts(2352)
*/

export interface PaymentHistory {
  id: number
  payment_date: string
  payment_id: string
  payment_method: string
  amount: number
  status: string
}

export type ExportFilterPaymentHistory = {
  id: number
  payment_date: string
  payment_id: string
  payment_method: string
}

export function prepareForExport(
  selection: PaymentHistory[],
): ExportFilterPaymentHistory[] {
  const filter: ExportFilterPaymentHistory[] = selection.map((row) => {
    const item: ExportFilterPaymentHistory = {
      id: row.id,
      payment_date: row.payment_date,
      payment_id: row.payment_id,
      payment_method: row.payment_method,
    }
    return item
  })
  console.log('exportFilter=', filter)
  return filter
}

export const initialPaymentHistory: PaymentHistory = {
  id: 0,
  payment_date: '2010-01-01',
  payment_id: 'XXXXXX',
  payment_method: 'Credit Card',
  amount: 99,
  status: 'success',
}

export const deletePaymentHistory = async (id: number) => {
  try {
    const { data, error } = await createClient()
      .from('paymenthistory')
      .delete()
      .match({ id: id })

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return { success: !error }
    //return data as PaymentHistory[]
  } catch (error) {
    const message = String(error)
    console.log(message)
    throw error
  }
}

export const deletePaymentHistoryList = async (ids: number[]) => {
  try {
    const { data, error } = await createClient()
      .from('paymenthistory')
      .delete()
      .in('id', ids)

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return { success: !error }
    //return data as PaymentHistory[]
  } catch (error) {
    const message = String(error)
    console.log(message)
    throw error
  }
}

export const getPaymentHistory = async () => {
  try {
    const { data, error } = await createClient().from('paymenthistory').select()

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data as PaymentHistory[]
  } catch (error) {
    const message = String(error)
    console.log(message)
    throw error
  }
}
